import { render } from "./GhostDetailsModal.vue?vue&type=template&id=6e06a785&scoped=true"
import script from "./GhostDetailsModal.vue?vue&type=script&lang=js"
export * from "./GhostDetailsModal.vue?vue&type=script&lang=js"

import "./GhostDetailsModal.vue?vue&type=style&index=0&id=6e06a785&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e06a785"]])

export default __exports__